<template>
    <div id="appList">
        <com-loading></com-loading>
        <com-header></com-header>
        <div class="main floatBotOuter">
            <div v-for="projectObj in sortProjects"
                :key="projectObj.projectId"
                class="floatBox"
                @click="toProject(projectObj)">
                <p>{{projectObj.projectName}}</p>
                <div class="count">{{projectObj.monthCount}}/{{projectObj.totalCount}}</div>
                <i class="fa fa-times deleteBtn"
                    aria-hidden="true"
                    @click.stop="showDelteModal(projectObj.projectId)"></i>
                <i class="fa startBtn"
                    :class="{'fa-star-o': !projectObj.hasOwnProperty('star') || !projectObj.star, 'fa-star': projectObj.hasOwnProperty('star') && projectObj.star}"
                    aria-hidden="true"
                    @click.stop="toggleStar(projectObj.projectId)"></i>
            </div>
            <div class="project floatBox"
                @click="showNewProjectInput">
                <i class="fa fa-plus-circle"
                    aria-hidden="true"></i>
            </div>
        </div>
        <com-modal modalType="input"
            modalId="newProjectInputModal"
            title="請輸入歌曲名稱"
            ok-title="新建"
            emptyInputAlert="歌曲名稱請勿空白"
            @confirm="createNewProject"></com-modal>
    
        <com-modal modalType="confirm"
            modalId="deleteConfirmModal"
            title="確認刪除此歌曲? (已上傳樂譜將同步刪除)"
            @confirm="deleteProject"></com-modal>
    </div>
</template>

<script>
import router from '@/router';
import { mapActions, mapGetters, mapMutations, } from 'vuex';
import { log } from '@/js/function';
import sys from '@/js/variable';
import comHeader from '@/components/com-header.vue';

export default {
    components: {
        comHeader,
    },
    props: {},
    data: () => ({
        deleteProjectId: null,
        projects: [],
    }),
    methods: {
        ...mapMutations(['mutationLoading', 'mutationSelectProject']),
        ...mapActions(['actionGetUserData', 'actionUpdateProjects', 'actionDeleteFile', 'actionUpdateLastSignIn', 'actionInitUserData', 'actionDeleteProjectFiles']),
        loadData() {
            // load project data AND check list signIn time
            this.mutationLoading(true);
            this.actionGetUserData().then((data) => {
                // create user data when first signUp
                if (!data) {
                    this.actionInitUserData();
                    this.mutationLoading(false);
                } else {
                    let projectData = (data.hasOwnProperty('projects')) ? data.projects : [];
                    const lastSignIn = (data.hasOwnProperty('lastSignIn')) ? data.lastSignIn : null;
                    // check lastSignIn
                    const now = new Date();
                    const last = new Date(lastSignIn);
                    if (now.getFullYear() !== last.getFullYear() || now.getMonth() !== last.getMonth()) {
                        // reset month play number
                        log('reset month count');
                        projectData = projectData.map((projectObj) => {
                            projectObj.monthCount = 0;
                            return projectObj;
                        });
                        this.actionUpdateProjects({ projectArray: projectData })
                            .then(() => {
                                this.projects = projectData;
                                this.mutationLoading(false);
                            })
                    } else {
                        this.projects = projectData;
                        this.mutationLoading(false);
                    }
                    // update last signIn
                    this.actionUpdateLastSignIn();
                }
            })
        },
        toProject(project) {
            ga('send', 'event', 'toProject', this.getUser.email);
            this.mutationSelectProject(project);
            router.push({
                name: 'project',
                params: { id: project.projectId }
            });
        },
        showNewProjectInput() {
            this.$root.$emit('show::modal', 'newProjectInputModal');
        },
        createNewProject(projectName) {
            ga('send', 'event', 'createNewProject', this.getUser.email);
            this.mutationLoading(true);
            const uuidv1 = require('uuid/v1');
            const newProjectData = {
                projectId: uuidv1(),
                projectName,
                totalCount: 0,
                monthCount: 0,
                speed: sys.defaultSpeed,
                countDownBeats: sys.defaultCountDownBeats,
            };
            this.projects.push(newProjectData);
            this.actionUpdateProjects({ projectArray: this.projects })
                .then(() => {
                    this.mutationLoading(false);
                })
                .catch((err) => {
                    this.mutationLoading(false);
                });
        },
        showDelteModal(projectId) {
            this.deleteProjectId = projectId;
            this.$root.$emit('show::modal', 'deleteConfirmModal');
        },
        deleteProject() {
            ga('send', 'event', 'deleteProject', this.getUser.email);
            this.mutationLoading(true);
            const deleteProjectObj = this.projects.filter(projectObj => projectObj.projectId === this.deleteProjectId)[0];
            this.projects = this.projects.filter(projectObj => projectObj.projectId !== this.deleteProjectId);
            // delete project info in DB
            const promiseArray = [this.actionUpdateProjects({ projectArray: this.projects })];
            // delete upload img in storage
            // firebase not support delete whole folder yet: https://stackoverflow.com/questions/38214052/delete-folder-with-contents-from-firebase-storage
            if (deleteProjectObj.hasOwnProperty('images')) {
                deleteProjectObj.images.forEach((file) => {
                    promiseArray.push(this.actionDeleteFile({
                        projectId: this.deleteProjectId,
                        file,
                    }))
                })
            }
            if (deleteProjectObj.hasOwnProperty('record')) {
                deleteProjectObj.record.forEach((recordObj) => {
                    promiseArray.push(this.actionDeleteFile({
                        projectId: this.deleteProjectId,
                        file: recordObj.fileName,
                    }))
                })
            }
            Promise.all(promiseArray)
                .then(() => {
                    this.deleteProjectId = null;
                    this.mutationLoading(false);
                })
                .catch((err) => {
                    this.mutationLoading(false);
                });
        },
        toggleStar(projectId) {
            ga('send', 'event', 'toggleStar', this.getUser.email);
            this.mutationLoading(true);
            this.projects = this.projects.map((projectObj) => {
                if (projectObj.projectId === projectId) {
                    if (!projectObj.hasOwnProperty('star')) {
                        projectObj.star = true;
                    } else {
                        projectObj.star = !projectObj.star;
                    }
                }
                return projectObj;
            })
            this.actionUpdateProjects({ projectArray: this.projects })
                .then(() => {
                    this.mutationLoading(false);
                })
                .catch((err) => {
                    this.mutationLoading(false);
                });
        },
    },
    computed: {
        ...mapGetters(['getUser']),
        sortProjects() {
            // return this.projects;
            const resultArray = this.projects.reduce((result, projectObj) => {
                if (projectObj.hasOwnProperty('star') && projectObj.star) result.star.push(projectObj);
                else result.unstar.push(projectObj);
                return result;
            }, {
                    star: [],
                    unstar: [],
                });
            return resultArray.star.concat(resultArray.unstar);
        },
    },
    watch: {},
    beforeCreate() { },
    created() {
        this.loadData();
    },
    beforeMount() { },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
}

</script>

<style lang="scss">
@import '../style/main.scss';
@import '../style/variable.scss';
#appList {
    .floatBotOuter {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        align-content: stretch;
        flex-wrap: wrap;
    }

    .floatBox {
        @include verticalCenter;
        float: left;
        position: relative;
        background: rgba(150, 150, 150, .2);
        cursor: pointer;
        font-weight: 800;
        padding: 10px;
        min-height: 100px;
        width: calc(100% / 6);
        border: 1px solid rgba(200, 200, 200, .5);
        @include mainRwd($dt) {
            width: calc(100% / 5);
        }
        @include mainRwd($pad) {
            width: calc(100% / 4);
        }
        @include mainRwd($mobile) {
            width: calc(100% / 3);
        }
        @include mainRwd($mobilePortrait) {
            width: calc(100% / 2);
        }
        p {
            margin: 0;
        }
        i {
            font-size: 1.5rem;
        }
        .count {
            position: absolute;
            bottom: 0;
            right: 2px;
            font-size: 0.9rem;
            font-weight: 300;
        }
        .deleteBtn {
            color: transparent;
            position: absolute;
            top: -2px;
            right: 0px;
        }
        .startBtn {
            position: absolute;
            color: black;
            top: 5px;
            left: 5px;
            font-size: 1rem;
            &:hover {
                color: $starYellow;
            }
            &.fa-star {
                color: $starYellow;
            }
        }
        .previewBtn {
            color: transparent;
            position: absolute;
            bottom: 0px;
            right: 0px;
        }
        &:hover {
            background: rgba(0, 0, 0, 0.5);
            color: white;
            transition: all .5s ease;
            .deleteBtn,
            .previewBtn {
                color: black;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// app-list.vue?dcb22efc